import type { AxiosError } from 'axios';
import type { CreatorPostStat } from 'backend';
import { createQuery } from 'react-query-kit';

import { supabase } from '../../supabase-client';

type Response = CreatorPostStat[];
type Variables = { uid?: string };

export const useAllStats = createQuery<Response, Variables, AxiosError>({
  queryKey: ['all-post-stats'],
  fetcher: async ({ uid } = {}) => {
    if (!uid) {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error('Not authenticated');
      uid = user.id;
    }

    const { data, error } = await supabase
      .from('creatorPosts')
      .select(
        `
        creatorPostStats!inner (*)
      `,
      )
      .eq('uid', uid);

    if (error) throw error;
    return data?.flatMap((post) => post.creatorPostStats) || [];
  },
});
